import React from 'react';
import { Form } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import { BlueButton } from '@share/components';

import { CheckboxGroup } from '../checkbox-group';
import { CheckboxLabel } from '../checkbox-label';
import { FormSection } from '../form-section';
import { usePaymentFormValidationRules } from '../../payment-form-validation-context';

import formStyles from '../../styles.module.scss';

interface PurchaseAgreementFooterProps {
  agreementChargeLabel: string;
  agreeCharge: boolean | undefined;
  agreeTerms: boolean | undefined;
  submitting: boolean;
  onOpenTerms: () => void;
  onSubmit: () => void;
}

export function PurchaseAgreementFooter({
  agreementChargeLabel,
  agreeCharge,
  agreeTerms,
  submitting,
  onOpenTerms,
  onSubmit,
}: PurchaseAgreementFooterProps): React.ReactElement {
  const intl = useIntl();
  const validationRules = usePaymentFormValidationRules();

  return (
    <FormSection>
      <CheckboxGroup>
        <Form.Item
          name="agreeCharge"
          valuePropName="checked"
          noStyle
          rules={validationRules.agreeCharge}
          className={formStyles.checkboxFormItem}
        >
          <CheckboxLabel>{agreementChargeLabel}</CheckboxLabel>
        </Form.Item>
        <Form.Item
          name="agreeTerms"
          valuePropName="checked"
          noStyle
          rules={validationRules.agreeTerms}
          className={formStyles.checkboxFormItem}
        >
          <CheckboxLabel>
            <>
              <FormattedMessage id="certificates.payment.agreement.termsLead" />{' '}
              <button type="button" className={formStyles.termsLink} onClick={onOpenTerms}>
                <FormattedMessage id="certificates.payment.agreement.termsLink" />
              </button>
            </>
          </CheckboxLabel>
        </Form.Item>
      </CheckboxGroup>
      <div className={formStyles.submitButtonWrapper}>
        <p className={formStyles.disclaimer}>
          <FormattedMessage id="certificates.payment.disclaimer" />
        </p>
        <BlueButton
          type="primary"
          className={formStyles.submitButton}
          disabled={submitting || !agreeCharge || !agreeTerms}
          htmlType="button"
          onClick={onSubmit}
          loading={submitting}
        >
          {submitting
            ? intl.formatMessage({ id: 'certificates.payment.processing' })
            : intl.formatMessage({ id: 'certificates.payment.completePurchase' })}
        </BlueButton>
      </div>
    </FormSection>
  );
}
